import React from 'react'

interface EmptyStateProps {
  icon: React.ReactNode
  title: string
  description: string
  className?: string
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  className = '',
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center bg-white/80 dark:bg-[#FFFFFF0D] rounded-2xl py-[40px] px-[24px] sm:px-[60px] md:px-[110px] ${className}`}
    >
      {icon}
      <div className="lg:max-w-[500px] md:max-w-[340px] max-w-[280px] break-words">
        <h3 className="text-2xl font-extralight text-gray-900 dark:text-white mb-2 truncate ">
          {title}
        </h3>
        <p className="text-gray-500 dark:text-gray-400 text-sm max-w-xl break-words">
          {description}
        </p>
      </div>
    </div>
  )
}

export default EmptyState
